export enum ContributionTypeEnum {
    UnKnown = -1,
    NoContribution = 1,
    Percentage = 2,
    DollarAmount = 3,
    EEPaysFlatAmount = 4,
  }
  
  export enum ContributionTypeTextEnum {
    UnKnown = 'UnKnown',
    NoContribution = 'No Contribution',
    Percentage = 'Percentage',
    DollarAmount = 'Dollar Amount',
    EEPaysFlatAmount = 'EE Pays Flat Amount',
  }
  
  export enum ContributionPlanTypeEnum {
    SelectedPlan = 1,
    AnyPlan = 2,
    LowestCostPlan = 3,
    NoContribution = 4,
  }
  
  export enum ContributionPlanTypeTextEnum {
    SelectedPlan = 'Selected Plan',
    AnyPlan = 'Any Plan',
    LowestCostPlan = 'Lowest Cost Plan',
    NoContribution = 'No Contribution',
  }
  
  export enum FlatContributionAmountTypeTextEnum {
    EmployerPays = 'Employer Pays',
    EmployeePays = 'Employee Pays',
  }
  
  export enum DefaultMinimumEnum {
    EmployerContribution = 100,
    EmployeeContributionPercent = 50,
  }
  export enum ParentType {
    QLM, //Medical
    QLD, //Dental
    QLV, //Vision
  }
  
  export enum SupportedContributionType {
    none = 0,
    percent = 1,
    dollar = 2,
  }
  